import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';
import clsx from 'clsx';

import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles(({ theme }) => ({
    tooltip: {
        margin: theme.spacing(0, 1)
    }
}));

const TooltipIcon = ({ icon, text, className }) => {
    const classes = useStyles();
    return (
        <Tooltip className={clsx(classes.tooltip, className)} disableFocusListener title={text} enterTouchDelay={100}>
            {icon ?? <InfoIcon/>}
        </Tooltip>
    );
};

TooltipIcon.propTypes = {
    icon: PropTypes.node,
    text: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default TooltipIcon;
